import { ThemeUICSSObject, responsive, spacing } from '@apia/theme';
/* IMPORT HERE */

const tree: ThemeUICSSObject = {
  height: '30vh',

  '&.readonly': {
    background: 'form.fields.readonly.backgroundColor',
  },
  '&.disabled': {
    background: 'form.fields.disabled.backgroundColor',
  },

  border: '1px solid',
  borderColor: 'palette.border.field',
  p: spacing(4),

  '&.focused': {
    borderColor: 'outlineColor',
  },

  li: {
    cursor: 'pointer',
    textAlign: 'left',
  },
  '[aria-selected="true"] > span': {
    fontWeight: 'bold',
  },

  '.tree__custom__icon': {
    width: responsive({
      0: '24px',
      3: '32px',
    }),
    height: responsive({
      0: '24px',
      3: '32px',
    }),
  },

  readonlyTree: {
    ul: {
      listStyle: 'revert',
    },
  },
  /* PREPEND HERE */
};

export default tree;
